"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFooterData = exports.footerSlice = exports.fetchFooter = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const app_1 = require("../../Endpoints/app");
const initialState = {
    footer: null
};
exports.fetchFooter = (0, toolkit_1.createAsyncThunk)('fetchFooterData', (pageId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, app_1.getFooterData)(pageId);
    return response;
}));
exports.footerSlice = (0, toolkit_1.createSlice)({
    name: 'header',
    initialState,
    extraReducers: builder => {
        builder.addCase(exports.fetchFooter.fulfilled, (state, action) => {
            state.footer = action.payload;
        });
    },
    reducers: {
        setFooterData: (state, action) => {
            state.footer = action.payload;
        }
    }
});
exports.setFooterData = exports.footerSlice.actions.setFooterData;
exports.default = exports.footerSlice.reducer;
